var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 19,
    viewBox: "0 0 27 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 1.46776C21.4817 2.20411 22.5 3.73314 22.5 5.5C22.5 7.26686 21.4817 8.79589 20 9.53224M22 14.7664C23.5115 15.4503 24.8725 16.565 26 18M6 18C7.94649 15.5226 10.5892 14 13.5 14C16.4108 14 19.0535 15.5226 21 18M18 5.5C18 7.98528 15.9853 10 13.5 10C11.0147 10 9 7.98528 9 5.5C9 3.01472 11.0147 1 13.5 1C15.9853 1 18 3.01472 18 5.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.46776C5.51828 2.20411 4.5 3.73314 4.5 5.5C4.5 7.26686 5.51828 8.79589 7 9.53224M5 14.7664C3.48854 15.4503 2.12748 16.565 1 18M21 18C19.0535 15.5226 16.4108 14 13.5 14C10.5892 14 7.94649 15.5226 6 18M9 5.5C9 7.98528 11.0147 10 13.5 10C15.9853 10 18 7.98528 18 5.5C18 3.01472 15.9853 1 13.5 1C11.0147 1 9 3.01472 9 5.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientIcon);
export default __webpack_public_path__ + "static/media/ClientIcon.9f9cd5e359a65501b6cafad839ae564d.svg";
export { ForwardRef as ReactComponent };